import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { format, addDays } from "date-fns";
import Modal from "react-modal";
import CommonFilterStructure from "../../../components/common-components/CommonFilterStructure";
import ModalHeader from "../../../components/ModalHeader";
import SelectExportables from "../../../components/common-components/SelectExportables";
import { fetchExportApiData } from "../../../redux/reducers/commonApiSlice";
import { export_dashboard_reports_details_v2 } from "../../../data/ApiEndpoints";
import { dashboardReportsDetailsV2 } from "../../../components/pt-trials/common/SharedDatas";
import CommonBroadForm from "../../../components/common-components/broadcast-template/CommonBroadForm";
import { isDev } from "../../../components/common-data/Commons";
import { isBroadcastCreateAllowedEmail } from "../../../components/common-data/Accessibles";

const TableFilters = ({
  user,
  allFilters,
  setAllFilters,
  salesTodayValues,
  onClickSearch,
  searchFilterApplied,
  onClickReset,
  canPlanFilters,
  totalSaleData,
  totalMemberData,
  isActiveDate,
  isUnpaidDate,
  clickedCard,
  cardType,
  isDisableFutureDates,
  filters,
  isUPMembersPage,
  setModValues,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { exportData, exportLoading } = useSelector((state) => state.common);
  const { loadingDup } = useSelector((state) => state.common);

  const isBroadcastCreateAllowed =
    isDev || isBroadcastCreateAllowedEmail(user?.email);

  const [openDateRanger, setOpenDateRanger] = useState(false);
  const initialRangeState = [
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ];
  const [rangeState, setRangeState] = useState(initialRangeState);
  const initialClickValues = {
    isModOpen: false,
    cardName: "",
    from: "",
  };
  const [clickValues, setClickValues] = useState(initialClickValues);
  const [csvData, setCsvData] = useState();

  const [isFilterSegmentShown, setIsFilterSegmentShown] = useState(true);

  const onCloseModal = () => {
    setClickValues(initialClickValues);
    setIsFilterSegmentShown(true);
  };

  const handleDateRangeChange = (item) => {
    setRangeState([item?.selection]);

    const formattedStartDate = format(item?.selection?.startDate, "yyyy-MM-dd");
    const formattedEndDate = format(item?.selection?.endDate, "yyyy-MM-dd");

    setAllFilters({
      ...allFilters,
      selectedStartDate: formattedStartDate,
      selectedEndDate: formattedEndDate,
    });
  };

  const clearDateRanger = () => {
    setOpenDateRanger(false);
    setRangeState(initialRangeState);
    setAllFilters({
      ...allFilters,
      selectedStartDate: "",
      selectedEndDate: "",
    });
  };

  const onClickExport = (filters) => {
    if (filters.is_export) {
      dispatch(
        fetchExportApiData({
          method: "GET",
          endpoint: export_dashboard_reports_details_v2,
          payload: {
            filters: filters,
          },
          token: user?.token,
        })
      );
    }
  };

  useEffect(() => {
    if (exportData) {
      setCsvData(exportData);
    } else {
      setCsvData();
    }
  }, [exportData]);

  return (
    <>
      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            clickValues.cardName === "broadcast_data"
              ? "mod-height-95vh broadcast-modal"
              : ""
          }`}
        >
          <ModalHeader
            title={
              clickValues.cardName === "exportModal"
                ? "Select Fields To Export"
                : clickValues.cardName === "broadcast_data"
                ? "Broadcast Message"
                : clickValues.cardName?.replace(/_/g, "")
            }
            onClick={onCloseModal}
          />

          {clickValues.cardName === "exportModal" ? (
            <div>
              <SelectExportables
                name={"sales-table"}
                exportableData={dashboardReportsDetailsV2}
                filters={filters}
                callFunction={onClickExport}
                isLoadingCSV={exportLoading}
                csvData={csvData}
                setCsvData={setCsvData}
              />
            </div>
          ) : clickValues.cardName === "broadcast_data" ? (
            <>
              {isFilterSegmentShown && (
                <CommonFilterStructure
                  from={"sales-table"}
                  isSegment={true}
                  decryptedText={user}
                  setFilters={setAllFilters}
                  filters={allFilters}
                  openDateRanger={openDateRanger}
                  onClickReset={onClickReset}
                  handleDateRangeChange={handleDateRangeChange}
                  setOpenDateRanger={setOpenDateRanger}
                  rangeState={rangeState}
                  clearDateRanger={clearDateRanger}
                  canPlanFilters={canPlanFilters}
                  isActiveDate={isActiveDate}
                  isUnpaidDate={isUnpaidDate}
                  clickedCard={clickedCard}
                  cardType={cardType}
                  isDisableFutureDates={isDisableFutureDates}
                  otherUserLabel={
                    clickedCard === "unpaid_members" ||
                    clickedCard === "expiring_today" ||
                    clickedCard === "expiring_this_month" ||
                    clickedCard === "active_members"
                      ? "Added By"
                      : null
                  }
                  isUPMembersPage={isUPMembersPage}
                  isBroadcastModal={true}
                />
              )}

              <CommonBroadForm
                from={clickValues.from}
                filters={filters}
                allFilters={allFilters}
                userInfoData={user}
                closeModal={onCloseModal}
                setIsFilterSegmentShown={setIsFilterSegmentShown}
              />
            </>
          ) : null}
        </div>
      </Modal>

      <CommonFilterStructure
        from="sales-table"
        decryptedText={user}
        salesTodayValues={salesTodayValues}
        totalSaleData={totalSaleData}
        totalMemberData={totalMemberData}
        setFilters={setAllFilters}
        filters={allFilters}
        openDateRanger={openDateRanger}
        onClickReset={onClickReset}
        handleDateRangeChange={handleDateRangeChange}
        setOpenDateRanger={setOpenDateRanger}
        rangeState={rangeState}
        onClickSearch={onClickSearch}
        searchFilterApplied={searchFilterApplied}
        clearDateRanger={clearDateRanger}
        canPlanFilters={canPlanFilters}
        isActiveDate={isActiveDate}
        isUnpaidDate={isUnpaidDate}
        clickedCard={clickedCard}
        cardType={cardType}
        isDisableFutureDates={isDisableFutureDates}
        onClickExportBtn={() =>
          setClickValues({
            isModOpen: true,
            cardName: "exportModal",
          })
        }
        otherUserLabel={
          clickedCard === "unpaid_members" ||
          clickedCard === "expiring_today" ||
          clickedCard === "expiring_this_month" ||
          clickedCard === "active_members"
            ? "Added By"
            : null
        }
        isUPMembersPage={isUPMembersPage}
        onClickBroadcastBtn={
          isBroadcastCreateAllowed &&
          (clickedCard === "unpaid_members" ||
            clickedCard === "expiring_today" ||
            clickedCard === "expiring_this_month" ||
            clickedCard === "active_members")
            ? () => {
                setClickValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "broadcast_data",
                  from: clickedCard,
                }));
                setModValues((prevs) => ({
                  ...prevs,
                  modName: "broadcast_data",
                }));
              }
            : null
        }
        isReload={callFunction}
        isLoading={loadingDup}
      />
    </>
  );
};

export default TableFilters;
